module.exports = __webpack_public_path__ + "img/l-06.c3792f91.png";